/**
 * A small Result type used by the pure validation/parse functions so callers get
 * friendly, surfaced errors instead of thrown exceptions.
 */
export type ParseResult<T> =
  | { ok: true; value: T }
  | { ok: false; errors: string[] };

export function ok<T>(value: T): ParseResult<T> {
  return { ok: true, value };
}

export function err<T>(errors: string[]): ParseResult<T> {
  return { ok: false, errors };
}
